export default "__VITE_ASSET__xXIXUMXe__"